export const STORE_URL = 'https://www.nuevonivel.shop'

/** Checkout directo — Mega Pack Esencial ($19.990 ARS) */
export const CHECKOUT_ESENCIAL =
  'https://www.nuevonivel.shop/cart/50102503604464:1'

/** Checkout directo — Pack Premium ($27.990 ARS) */
export const CHECKOUT_PREMIUM =
  'https://www.nuevonivel.shop/cart/50102780002544:1'
